import useResource from 'util/resource/useResource';
import { AttachmentListDTO } from './conversationTypes';
import config from 'config';

export const useConversationAttachments = (conversationId?: UUID) => {
  const key = conversationId ? `${config.COMPANIES_API_URL}/conversations/${conversationId}/attachments` : undefined;
  return useResource<AttachmentListDTO>(key);
};
